import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ConservationBenchmark, IndicatorName } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { HabitatIntactnessHistorical } from '@/components/Charts/HabitatIntactnessHistorical';
import { GraphFact } from '@/components/Charts/types';
import { useTrendLabelFromPlotFact } from '@/hooks/useTrendLabelFromFact';
import { NoPlotData } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plot/components/NoPlotData';

export const HabitatIntactnessGraphTile = ({
  data,
  benchmark,
  benchmarks,
}: {
  data: GraphFact[] | null | undefined;
  benchmark: ConservationBenchmark | null;
  benchmarks: Record<ConservationBenchmark, number | undefined> | undefined;
}) => {
  const { t } = useTranslation();

  const trendLabel = useTrendLabelFromPlotFact({
    fact: IndicatorName.habitat_intactness_total_previous_5y_pct_change,
  });

  const noChartData = !data || data.length === 0;

  if (noChartData) {
    return <NoPlotData />;
  }

  return (
    <Stack center data-testid='habitat-intactness-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.habitatIntactness.labels.graphHeadline')}
          className='w-full px-6 sm:px-0'
          popover={{
            title: t('shared.ncaDetail.details.habitatIntactness.labels.graphHeadline'),
            body: t('shared.ncaDetail.details.habitatIntactness.labels.graphHeadlineTooltip'),
          }}
        />
        <HabitatIntactnessHistorical
          data={data}
          benchmark={benchmark}
          benchmarks={benchmarks}
          trendLabel={trendLabel}
        />
      </Stack>
    </Stack>
  );
};
